<template>
<div>
  <program-head :isNeedBack="false" />
  <empty-info :icon="icon" />
</div>
</template>

<script>
import EmptyInfo from "../partials/EmptyInfo";
import ProgramHead from "./ProgramHead";
export default {
  name: "ProgramEmpty",
  components: {ProgramHead, EmptyInfo},
  props: {
    icon: {
      type: String,
      default: function() {
        return '/img/emptyIcon.png'
      }
    }
  },
  computed: {
    isNewTrade: {
      get() {
        return this.$store.state.isNewTrade;
      },
      set(value) {
        this.$store.commit('setter', {isNewTrade: value})
      }
    },
    isEditTrade() {
      return this.$store.state.isEditTrade;
    },
  },
  methods: {
    newTrade() {
      this.isNewTrade = !this.isNewTrade;
    },
  }
}
</script>

<style scoped>

</style>
